<template>
  <div class="tree-wrap">
    <div class="el-tree-1">
      <el-tree ref="tree" :data="data" :empty-text="emptyText" :props="defaultProps" :lazy="true" :load="getData" @node-click="nodeClick"></el-tree>
    </div>
  </div>
</template>

<script>

  import { UserManage } from './common.js'

  export default {
    name: 'department-tree',
    props: {
      api: {
        type: String,
        default() {
          return ""
        }
      }
    },
    data() {
      return {
        data: [],
        emptyText: '没有数据',
        defaultProps: {
          label: 'departmentName',
          isLeaf: 'leaf',
        }
      }
    },
    created() {

      UserManage.getUserDepartment({phone: '15015807937'}, res => {
        this.data = res.code == 0 ? res.data : []
      })

    },
    watch: {

    },
    methods: {

      getData(node, resolve) {

        UserManage.getDepartmentList({department_id: node.data.departmentID}, res => {
          resolve(res.code == 0 ? res.data.list : [])
        })

      },

      nodeClick(data, node) {
        var d = {
          level: node.level,
          data: node.data,
        }
        this.$emit('node-click', d)
      },


    }
  }
</script>

<style lang="scss" scoped>
  .el-tree-1{
    overflow-y: scroll;
    height: calc( 100vh - 220px );
    width: 100%;
  }
  .tree-wrap {
    width: 250px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/department-tree.vue